import { render } from "./Saving_Product_Details.vue?vue&type=template&id=a0e4f4c4"
import script from "./Saving_Product_Details.vue?vue&type=script&lang=js"
export * from "./Saving_Product_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__